import AmenitiesList from '../amenities-list';

export default function AmenitiesTab() {
    return <AmenitiesList />
}